/* Project Import will be here */
import { getErrorObject, errorToast } from "utilities/utils";
import { getSalesReturnHistoryListApi, getSalesReturnHistoryDetailsApi } from "services/salesReturn/salesReturnHistory";
import { navigateToSalesReturnHistory } from "app/navigation";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
import { ISalesReturnHistoryDetailsParams } from "models/salesReturnModels";
import { IOrderHistoryFilterParams } from "models/orderModels";
/* Project Import will be here */

export const types = {
    SALES_RETURN_HISTORY_REQUEST: "salesReturnHistory/SALES_RETURN_HISTORY_REQUEST",
    SALES_RETURN_HISTORY_SUCCESS: "salesReturnHistory/SALES_RETURN_HISTORY_SUCCESS",
    SALES_RETURN_HISTORY_FAILURE: "salesReturnHistory/SALES_RETURN_HISTORY_FAILURE",
    SALES_RETURN_HISTORY_DETAIL_REQUEST: "salesReturnHistory/SALES_RETURN_HISTORY_DETAIL_REQUEST",
    SALES_RETURN_HISTORY_DETAIL_SUCCESS: "salesReturnHistory/SALES_RETURN_HISTORY_DETAIL_SUCCESS",
    SALES_RETURN_HISTORY_DETAIL_FAILURE: "salesReturnHistory/SALES_RETURN_HISTORY_DETAIL_FAILURE"
};

const initialState = {
    list: {
        data: [],
        isLoading: false,
        responseCount: 0,
        responseTotalCount: 0,
        error: null
    },
    details: {
        salesReturnId: null,
        Summary: {},
        ProductList: [],
        isLoading: false,
        error: null
    }
};

export const salesReturnHistory = (state = initialState, action) => {
    switch (action.type) {
        case types.SALES_RETURN_HISTORY_REQUEST: {
            return {
                ...state,
                list: {
                    ...state.list,
                    isLoading: true
                }
            };
        }
        case types.SALES_RETURN_HISTORY_SUCCESS: {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            };
        }
        case types.SALES_RETURN_HISTORY_FAILURE: {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.payload,
                    data: [],
                    responseCount: 0,
                    responseTotalCount: 0,
                    isLoading: false
                }
            };
        }
        case types.SALES_RETURN_HISTORY_DETAIL_REQUEST: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload,
                    isLoading: true
                }
            };
        }
        case types.SALES_RETURN_HISTORY_DETAIL_SUCCESS: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload,
                    isLoading: false,
                    error: null
                }
            };
        }
        case types.SALES_RETURN_HISTORY_DETAIL_FAILURE: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.payload,
                    isLoading: false
                }
            };
        }
        default:
            return state;
    }
};

export const getSalesReturnHistoryList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.SALES_RETURN_HISTORY_REQUEST });
        try {
            /* Fetch the order history from the server */
            const hFilter = getState().historyFilter;
            const requestObj: IOrderHistoryFilterParams = {
                SearchText: hFilter.searchText,
                FromDate: hFilter.month !== null ? hFilter.monthStartDate : hFilter.startDate,
                ToDate: hFilter.month !== null ? hFilter.monthEndDate : hFilter.endDate
            }

            const response = await getSalesReturnHistoryListApi(requestObj);

            dispatch({
                type: types.SALES_RETURN_HISTORY_SUCCESS,
                payload: {
                    data: response.data.Data,
                    responseCount: response.data.Count,
                    responseTotalCount: response.data.TotalCount
                }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SALES_RETURN_HISTORY_FAILURE));
        }
    };
};

export const getSalesReturnHistoryDetails = (data: ISalesReturnHistoryDetailsParams) => {
    return async dispatch => {
        dispatch({
            type: types.SALES_RETURN_HISTORY_DETAIL_REQUEST,
            payload: { salesReturnId: data.SalesReturnId }
        });

        try {
            /* Fetch the sales return history details from the server */
            const response = await getSalesReturnHistoryDetailsApi(data);

            const requestPayload = {
                Summary: response.data.OrderSummary[0],
                ProductList: response.data.Data
            };

            dispatch({
                type: types.SALES_RETURN_HISTORY_DETAIL_SUCCESS,
                payload: requestPayload
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SALES_RETURN_HISTORY_DETAIL_FAILURE, true));

            /* Navigate to sales return history list page */
            dispatch(navigateToSalesReturnHistory());
        }
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({
                type: type,
                payload: { error: message }
            });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};